import UtilityStandardTemplate from './Utility-standard-template';
import UtilityCallPermissionTemplate from './Utility-call-permission-template';
import SelectCards from '../components/Select-cards';
import MarketingStandardTemplate from '../Marketing-templates/Marketing-standard-template';

const messageTypeOptions = [
  { label: 'Standard', value: 'STANDARD', description: 'Text message with optional buttons' },
  {
    label: 'Call Permission',
    value: 'CALL_PERMISSION',
    description: 'Ask the user for permission to receive a phone call',
  },
];

const UtilityTemplates = ({ control, watch, ...props }) => {
  const watchMessageType = watch('messageType');

  return (
    <>
      <div className="w-full mt-3">
        <label className="form-label">Message Type</label>

        <SelectCards
          control={control}
          name="messageType"
          options={messageTypeOptions}
          defaultValue="STANDARD"
        />
      </div>

      {watchMessageType === 'STANDARD' && (
        <MarketingStandardTemplate control={control} watch={watch} mode="UTILITY" {...props} />
      )}

      {watchMessageType === 'CALL_PERMISSION' && (
        <UtilityCallPermissionTemplate control={control} watch={watch} {...props} />
      )}
    </>
  );
};
export default UtilityTemplates;
